import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface SalesUserIconStyles {
    salesUserIcon?: InjectableCss;
}

export const salesUserIconStyles: SalesUserIconStyles = {
    salesUserIcon: {
        css: css`
            display: flex;
            & svg {
                width: 32px !important;
                height: 32px !important;
            }
            & path {
                fill: #000;
                stroke: #000;
                stroke-width: 1.5px;
            }
        `,
    },
};

const styles = salesUserIconStyles;

const SalesUserIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.salesUserIcon}>
            <svg fill="#000000" height="1000px" width="1000px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <g>
                    <g>
                        <path d="M476.294,126.453H348.813v-22.251c0-22.589-18.378-40.967-40.967-40.967H204.154c-22.589,0-40.967,18.378-40.967,40.967
                            v22.251H35.706C16.018,126.453,0,142.471,0,162.158v250.9c0,19.689,16.018,35.706,35.706,35.706h440.587
                            c19.689,0,35.706-16.018,35.706-35.706v-250.9C512,142.471,495.982,126.453,476.294,126.453z M183.586,104.202
                            c0-11.342,9.227-20.569,20.569-20.569h103.691c11.341,0,20.569,9.227,20.569,20.569v22.251H183.586V104.202z M491.602,413.059
                            c0,8.441-6.867,15.308-15.308,15.308H35.706c-8.441,0-15.308-6.866-15.308-15.308V216.248L176.992,292.2
                            c3.174,19.356,20.012,34.174,40.251,34.174h77.514c20.239,0,37.077-14.818,40.251-34.174l97.809-47.442
                            c5.068-2.458,7.183-8.559,4.725-13.627c-2.457-5.069-8.558-7.185-13.627-4.725l-91.205,44.238
                            c-5.974-15.128-20.729-25.863-37.953-25.863h-77.514c-17.224,0-31.98,10.736-37.953,25.863L20.398,193.577v-31.419
                            c0-8.44,6.867-15.307,15.308-15.307h440.587c8.44,0,15.308,6.866,15.308,15.307V413.059z M196.845,285.578
                            c0-11.248,9.151-20.398,20.398-20.398h77.514c11.248,0,20.398,9.151,20.398,20.398s-9.151,20.398-20.398,20.398h-77.514
                            C205.995,305.976,196.845,296.825,196.845,285.578z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M477.458,211.773c-2.457-5.07-8.559-7.183-13.627-4.727l-6.258,3.035c-5.069,2.458-7.184,8.56-4.727,13.627
                            c1.763,3.635,5.399,5.751,9.184,5.751c1.493,0,3.01-0.328,4.443-1.024l6.258-3.035C477.8,222.942,479.915,216.84,477.458,211.773z
                            "/>
                    </g>
                </g>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(SalesUserIcon);
